var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bd"},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"tip"},[_vm._v(" 嗯？"),_c('br'),_vm._v(" 您好像不是管理员哦？"),_c('br'),_vm._v(" 身份证拿粗来看看！"),_c('br'),_vm._v(" 开玩笑的，哈哈哈哈~"),_c('br'),_vm._v(" 爱护小站，你我一起❤️ ")])])])
}]

export { render, staticRenderFns }